import { some } from 'lodash';
import { InternalCustomers } from './helpers';

export const getDevices = () => {
  return new Promise(async (resolve, reject) => {
    let devices = await navigator.mediaDevices.enumerateDevices();
    if (some(devices, { label: '' })) {
      try {
        const s = await navigator.mediaDevices.getUserMedia({
          audio: true,
          video: true,
        });
        devices = await navigator.mediaDevices.enumerateDevices();
        s.getTracks().forEach((t: any) => t.stop());
      } catch (e) {
        reject(e);
      }
    }
    resolve(devices);
  });
};

export function replaceHttpWithHttps(url: string) {
  if (url.includes('http://')) {
    return url.replace(/http:\/\//g, 'https://');
  }
  return url;
}

export const cleanAdditionalText = (text: string) => {
  return !!text ? text.replace(/^(&nbsp;|\s)+/, '') : '';
};

export const checkIfCustomerIsDevOrQA = (customerId: number) => {
  return (
    customerId.toString() === InternalCustomers.DEV ||
    customerId.toString() === InternalCustomers.QA_COVIDEO
  );
};
